import React from 'react'
import { projectFirestore} from '../firebase/config';

const BasicInfo = () => {
    fetch('https://ipapi.co/json/')
    .then(function(response) {
     response.json().then(jsonData => {
       projectFirestore.collection("Visiters").doc(jsonData.ip).set(jsonData);
     });
   }).catch(function(error) {
      console.log(error)
   });
}

export default BasicInfo

